var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikesCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "#258E61",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3994 13H6.74186C6.45851 13.0018 6.18344 12.9044 5.9643 12.7248C5.74515 12.5452 5.59571 12.2946 5.54187 12.0164L5.01987 9.21639C4.98796 9.04504 4.99426 8.86877 5.0383 8.70013C5.08235 8.5315 5.16305 8.37465 5.27467 8.24079C5.3901 8.10232 5.53466 7.99103 5.69804 7.91483C5.86142 7.83864 6.03959 7.79943 6.21986 7.79999H8.12826V6.2C8.12826 5.3756 8.97345 5 9.75865 5C9.86474 5 9.96648 5.04214 10.0415 5.11716C10.1165 5.19217 10.1586 5.29391 10.1586 5.4C10.1586 6.1628 10.2946 6.96399 10.4482 7.11359L11.5622 8.19999H13.3994C13.5055 8.19999 13.6073 8.24213 13.6823 8.31715C13.7573 8.39216 13.7994 8.4939 13.7994 8.59999V12.6C13.7994 12.7061 13.7573 12.8078 13.6823 12.8828C13.6073 12.9578 13.5055 13 13.3994 13ZM10.9994 8.76839L9.88985 7.68839C9.51785 7.32559 9.40505 6.4436 9.36985 5.8548C9.15305 5.9064 8.92625 6.0068 8.92625 6.202V8.20199C8.92625 8.30808 8.88411 8.40982 8.8091 8.48483C8.73408 8.55985 8.63234 8.60199 8.52626 8.60199H6.21786C6.15513 8.60154 6.09307 8.61493 6.0361 8.64121C5.97913 8.66748 5.92865 8.70599 5.88826 8.75399C5.85125 8.79766 5.82449 8.84908 5.80995 8.90446C5.79541 8.95983 5.79347 9.01776 5.80426 9.07399L6.32426 11.874C6.34486 11.9685 6.39789 12.0529 6.47416 12.1124C6.55044 12.172 6.64514 12.2029 6.74186 12.2H10.9994V8.76839ZM12.9994 8.99999H11.7994V12.2H12.9994V8.99999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikesCount);
export default __webpack_public_path__ + "static/media/likesCount.52beb76024d22196c536e758f7075220.svg";
export { ForwardRef as ReactComponent };